/*=========================================================================================
  File Name: teacherDates.js
  Description: Vuex store for all actions related to the teacherDate model
==========================================================================================*/
import axios from "axios";

const state = {
  teacherDates: [],
  currentTeacherDate: null,
};

const actions = {
  async fetchTeacherDate({ commit }, id) {
    const response = await axios.get(`api/TeacherDates/${id}`);
    commit("SET_CURRENT_TEACHER_DATE", response.data);
  },
  async addTeacherDates({ commit }, payload) {
    const response = await axios.post("api/TeacherDates", payload);
    commit("ADD_TEACHER_DATES", response.data);
  },
  async addMultipleTeacherDates({ commit }, payload) {
    const response = await axios.post("api/TeacherDates/Multiple", payload);
    commit("ADD_TEACHER_DATES", response.data);
  },
  async updateTeacherDates({ commit }, payload) {
    const response = await axios.put(
      `api/TeacherDates/${payload.dateId}`,
      payload
    );
    commit("UPDATE_TEACHER_DATES", response.data);
  },
};

const mutations = {
  SET_CURRENT_TEACHER_DATE(state, data) {
    state.currentTeacherDate = data;
  },
  ADD_TEACHER_DATES(state, data) {
    state.teacherDates.push(data);
  },
  UPDATE_TEACHER_DATES(state, data) {
    state.teacherDates = [
      ...state.teacherDates.map((item) =>
        item.id !== data.id ? item : { ...item, ...data }
      ),
    ];
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
